import { KuxFilteredCategoriesDTO, UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { action } from 'mobx';
import { container } from 'tsyringe';

import { errorHandling } from '../../../../utils/error-handling';
import { toast } from '../../../../utils/toast';
import { ErrorPriority } from '../../../error';
import { ParentalPinStore } from '../../../parentalPin';
import { UserStore } from '../../../user';
import { SubpageStore } from '../subpage-store';

import { ageThresholdValueUpdate } from './parental-control-services';

/**
 * @category Store
 */
export class ParentalControlStore extends SubpageStore {
  static moduleName = 'ParentalControlStore';

  parentalAgeGroups: string[] = [];
  private parentalPinStore: ParentalPinStore;

  constructor(props: KuxFilteredCategoriesDTO, categoryItem: KuxFilteredCategoriesDTO, children?: []) {
    super(props, categoryItem, children);
    this.parentalPinStore = container.resolve<ParentalPinStore>('parentalPinStore');
    if (props.parentalAgeGroups.length) {
      this.parentalAgeGroups = props.parentalAgeGroups.split(',').slice(0, 4);
    }
  }

  subtype: UIDAPresentationTypeEnum.parental_control = UIDAPresentationTypeEnum.parental_control;
  // TODO add other methods for parental-control

  @action
  @errorHandling({ type: ErrorPriority.low })
  @toast('setAgeThresholdValue')
  async setAgeThresholdValue(value: string) {
    const result = await ageThresholdValueUpdate(value);
    const userStore = container.resolve<UserStore>('userStore');
    await userStore.loadUserData();
    return result;
  }
}
